import { render, staticRenderFns } from "./AddCampaigne.vue?vue&type=template&id=a2b8ddec&"
import script from "./AddCampaigne.vue?vue&type=script&lang=js&"
export * from "./AddCampaigne.vue?vue&type=script&lang=js&"
import style0 from "./AddCampaigne.vue?vue&type=style&index=0&id=a2b8ddec&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2b8ddec')) {
      api.createRecord('a2b8ddec', component.options)
    } else {
      api.reload('a2b8ddec', component.options)
    }
    module.hot.accept("./AddCampaigne.vue?vue&type=template&id=a2b8ddec&", function () {
      api.rerender('a2b8ddec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/email/AddCampaigne.vue"
export default component.exports